import * as ss from 'superstruct';
import { ConversionFilterListResource } from '../filter';
import { OutputStreamDestinationConfig, StartFrom } from './types';
import { Id } from '../../types';
import { AdAccountRef } from '../../ad-platforms/ad-account.resource';

export const ConversionOutputStreamResource = ss.type({
  id: Id,
  filter: ss.pick(ConversionFilterListResource, ['id']),
  description: ss.optional(ss.nullable(ss.string())),
  startFrom: StartFrom,
  /** For StartFrom = 'timestamp'. */
  fromTimestampMs: ss.optional(ss.nullable(ss.number())),
  enabled: ss.boolean(),
  /** If this should be processed as events come in - this is hard on the system. */
  realtime: ss.boolean(),
  destination: OutputStreamDestinationConfig,
  /** For destinations that send to one; see `outputStreamAdAccountPlatform`. */
  adAccount: ss.optional(ss.nullable(AdAccountRef)),
  createdAt: ss.optional(ss.nullable(ss.date())),
  updatedAt: ss.optional(ss.nullable(ss.date())),
});

export type ConversionOutputStreamResource = ss.Infer<
  typeof ConversionOutputStreamResource
>;
